import { Button, Card, message, Popconfirm, Select, Space, Table, Typography } from "antd";
import { useEffect, useState } from "react";
import { serverFetch } from "../../../server";
import { selectFilterOption } from "../../../extensions/helper";
import { isMobile } from "@/extensions/design";
import "./user.css";

const { Text } = Typography;

const UserProducts = ({ id, onClose }) => {
  const [loading, setLoading] = useState(false);
  const [items, setItems] = useState([]);
  const [products, setProducts] = useState([]);
  const [productLoading, setProductLoading] = useState(false);
  const [selectedProductId, setSelectedProductId] = useState(null);

  const getData = () => {
    if (!id) return;
    setLoading(true);
    serverFetch(`User/ProductList/${id}`)
      .then(data => {
        setItems(data);
        setLoading(false);
      })
      .catch(e => {
        setLoading(false);
        message.error(e.userMessage);
      });
  };

  useEffect(getData, [id]);

  useEffect(() => {
    setProductLoading(true);
    serverFetch("product/ForSale?vid=1&active=true")
      .then(data => {
        setProducts(data.map(i => ({ value: i.id, label: i.name })));
        setProductLoading(false);
      })
      .catch(e => {
        message.error(e.userMessage);
        setProductLoading(false);
      });
  }, []);

  const onAdd = () => {
    if (!selectedProductId) {
      message.warning("Выберите услугу");
      return;
    }
    setLoading(true);
    serverFetch("User/ProductAdd", {
      method: "POST",
      bodyData: { userId: id, productId: selectedProductId }
    })
      .then(() => {
        setSelectedProductId(null);
        getData();
      })
      .catch(e => {
        setLoading(false);
        message.error(e.userMessage);
      });
  };

  const onDelete = (userProductId) => {
    setLoading(true);
    serverFetch(`User/ProductDelete/${userProductId}`, { method: "DELETE" })
      .then(() => {
        getData();
      })
      .catch(e => {
        setLoading(false);
        message.error(e.userMessage);
      });
  };

  const columns = [
    { title: "Наименование", dataIndex: "productName" },
    {
      title: "Действие",
      key: "action",
      width: 100,
      render: (_, record) => (
        <Popconfirm
          title="Удалить услугу?"
          description="Это действие нельзя отменить."
          onConfirm={() => onDelete(record.id)}
          okText="Да"
          cancelText="Нет"
        >
          <Button size="small" danger>Удалить</Button>
        </Popconfirm>
      ),
    },
  ];

  return !isMobile ? (
    <div className="sport-section">
      <Space style={{ marginBottom: 16 }}>
        <Select
          style={{ width: 300 }}
          placeholder="Выберите услугу"
          options={products}
          loading={productLoading}
          showSearch
          filterOption={selectFilterOption}
          value={selectedProductId}
          onChange={setSelectedProductId}
          allowClear
        />
        <Button onClick={onAdd} loading={loading} disabled={!selectedProductId}>
          Добавить
        </Button>
      </Space>
      <Table
        columns={columns}
        size="small"
        dataSource={items}
        loading={loading}
        pagination={false}
        rowKey="id"
      />
    </div>
  ) : (
    <div className="product-mobile-container">
      <div className="product-mobile-actions" style={{ display: "flex", gap: 8 }}>
        <Select
          style={{ flex: 1 }}
          placeholder="Выберите услугу"
          options={products}
          loading={productLoading}
          showSearch
          filterOption={selectFilterOption}
          value={selectedProductId}
          onChange={setSelectedProductId}
          allowClear
        />
        <Button onClick={onAdd} loading={loading} disabled={!selectedProductId}>
          Добавить
        </Button>
      </div>
      <div className="product-mobile-scroll">
        {items.map(item => (
          <Card key={item.id} className="product-packet-card-mobile" style={{ borderLeft: "4px solid #1677ff" }}>
            <div className="product-packet-card-row1-mobile">
              <Text strong>{item.productName}</Text>
              <Popconfirm
                title="Удалить услугу?"
                description="Это действие нельзя отменить."
                onConfirm={() => onDelete(item.id)}
                okText="Да"
                cancelText="Нет"
              >
                <Button size="small" danger>Удалить</Button>
              </Popconfirm>
            </div>
          </Card>
        ))}
        {items.length === 0 && !loading && <div className="product-packet-empty-mobile">Нет данных</div>}
      </div>
    </div>
  );
};

export default UserProducts;

